export default __webpack_public_path__ + "static/media/the.96eb6139.mp3";